module.exports = __webpack_public_path__ + "static/media/br.0dfd8bb0.svg";